import Cookies from 'js-cookie';

const markInfoBarAsRead = () => {
  Cookies.set('_isInfoRead', 'true', { expires: 1 });
};

export const infoBarEvents = [
  // closed.bs.alert odpala się po usunięciu elementu z DOM, więc nie dociera do delegacji na document.
  ['jsInfoBarDismissed', markInfoBarAsRead, 'close.bs.alert'],
];
